import { TextIcon } from "lucide-react";

import {
  RichTextDisplay,
  SheetSectionContainer,
  SheetSectionEmptyText,
  SheetSectionHeader,
} from "@/components";

export const SheetProfessionalSummary = ({
  containerClasses,
  professionalSummary,
}: {
  containerClasses?: string;
  professionalSummary: string | null;
}) => {
  if (!professionalSummary) {
    return (
      <SheetSectionContainer className={containerClasses}>
        <SheetSectionHeader
          icon={TextIcon}
          title="Professional Summary"
          isEmpty
        />
        <SheetSectionEmptyText text="This candidate hasn't added a professional summary." />
      </SheetSectionContainer>
    );
  }

  return (
    <SheetSectionContainer className={containerClasses}>
      <SheetSectionHeader icon={TextIcon} title="Professional Summary" />
      <RichTextDisplay richText={professionalSummary} />
    </SheetSectionContainer>
  );
};
